var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNext = function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6465 15.6464C24.8417 15.8417 24.8417 16.1583 24.6465 16.3535L17.8536 23.1464C17.5386 23.4614 17 23.2383 17 22.7929V18.8571L8.35718 18.8571C8.08104 18.8571 7.85718 18.6333 7.85718 18.3571L7.85718 13.6429C7.85718 13.3667 8.08104 13.1429 8.35718 13.1429L17 13.1429L17 9.2071C17 8.76165 17.5386 8.53857 17.8536 8.85355L24.6465 15.6464Z",
    fill: "currentColor"
  })));
};
export default SvgNext;